import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  "aria-label": "breadcrumb",
  class: "small"
}
const _hoisted_2 = {
  key: 0,
  class: "breadcrumb",
  style: {"background-color":"transparent","margin-bottom":"0","padding":"0"}
}
const _hoisted_3 = {
  key: 1,
  class: "progress",
  style: {"height":"19px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "progress-bar progress-bar-animated progress-bar-striped bg-light",
  role: "progressbar",
  style: {"width":"100%"},
  "aria-valuenow": "100",
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

import { onBeforeMount } from 'vue'
import { useStore } from "vuex";

interface Props {
  vendorCode: number,
  categoryId: number | null,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoCategoryPath',
  props: {
    vendorCode: null,
    categoryId: { default: null }
  },
  setup(__props: any) {

const props = __props as { vendorCode: number, categoryId: number | null };

const store = useStore()



const categoryPathById = store.getters['shopping/silpo/categories/categoryPathById']

onBeforeMount(async (): Promise<void> => {
  await store.dispatch('shopping/silpo/categories/init')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (!props.categoryId || _unref(categoryPathById)(props.categoryId).length > 0)
      ? (_openBlock(), _createElementBlock("ol", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoryPathById)(props.categoryId), (category, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `category-path-index-${index}-for-product-${props.vendorCode}`,
              class: "breadcrumb-item text-secondary"
            }, _toDisplayString(category), 1))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
  ]))
}
}

})